(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('agreementPoliciesProceduresComponent', agreementPoliciesProceduresComponent);

    agreementPoliciesProceduresComponent.$inject = [];

    function agreementPoliciesProceduresComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectiveAgreementPoliciesProceduresController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/agreement-policies-procedures.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectiveAgreementPoliciesProceduresController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectiveAgreementPoliciesProceduresController($scope, $stateParams, $element) {
        var vm = this;

        function init() {
            if (vm.workflow.answer.agreement) {
                if (vm.workflow.answer.agreement.dateSigned === null || vm.workflow.answer.agreement.dateSigned === undefined) {
                    vm.workflow.answer.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        init();
    }
})();
